/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WidgetRedirectRouteImport } from './routes/widget-redirect'
import { Route as CopilotRouteImport } from './routes/copilot'
import { Route as LayoutNosidebarRouteImport } from './routes/_layout-nosidebar'
import { Route as LayoutRouteImport } from './routes/_layout'
import { Route as LayoutIndexRouteImport } from './routes/_layout/index'
import { Route as WidgetChatRouteImport } from './routes/widget/chat'
import { Route as LayoutChatsRouteImport } from './routes/_layout/chats'
import { Route as LayoutNosidebarWelcomeRouteImport } from './routes/_layout-nosidebar/welcome'
import { Route as LayoutNosidebarUnauthorizedRouteImport } from './routes/_layout-nosidebar/unauthorized'
import { Route as LayoutNosidebarSpotlightRouteImport } from './routes/_layout-nosidebar/spotlight'
import { Route as LayoutNosidebarSmeRouteImport } from './routes/_layout-nosidebar/sme'
import { Route as LayoutNosidebarSalesforceRouteImport } from './routes/_layout-nosidebar/salesforce'
import { Route as LayoutNosidebarQuestionnaireRouteImport } from './routes/_layout-nosidebar/questionnaire'
import { Route as LayoutNosidebarManageUsersRouteImport } from './routes/_layout-nosidebar/manageUsers'
import { Route as LayoutNosidebarManageRolesRouteImport } from './routes/_layout-nosidebar/manageRoles'
import { Route as LayoutNosidebarManageRequestsRouteImport } from './routes/_layout-nosidebar/manageRequests'
import { Route as LayoutNosidebarFeedbackRouteImport } from './routes/_layout-nosidebar/feedback'
import { Route as LayoutNosidebarDocumentsRouteImport } from './routes/_layout-nosidebar/documents'
import { Route as LayoutChatsChatIdRouteImport } from './routes/_layout/chats.$chatId'

const WidgetRedirectRoute = WidgetRedirectRouteImport.update({
  id: '/widget-redirect',
  path: '/widget-redirect',
  getParentRoute: () => rootRouteImport,
} as any)
const CopilotRoute = CopilotRouteImport.update({
  id: '/copilot',
  path: '/copilot',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutNosidebarRoute = LayoutNosidebarRouteImport.update({
  id: '/_layout-nosidebar',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutRoute = LayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutIndexRoute = LayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutRoute,
} as any)
const WidgetChatRoute = WidgetChatRouteImport.update({
  id: '/widget/chat',
  path: '/widget/chat',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutChatsRoute = LayoutChatsRouteImport.update({
  id: '/chats',
  path: '/chats',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutNosidebarWelcomeRoute = LayoutNosidebarWelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => LayoutNosidebarRoute,
} as any)
const LayoutNosidebarUnauthorizedRoute =
  LayoutNosidebarUnauthorizedRouteImport.update({
    id: '/unauthorized',
    path: '/unauthorized',
    getParentRoute: () => LayoutNosidebarRoute,
  } as any)
const LayoutNosidebarSpotlightRoute =
  LayoutNosidebarSpotlightRouteImport.update({
    id: '/spotlight',
    path: '/spotlight',
    getParentRoute: () => LayoutNosidebarRoute,
  } as any)
const LayoutNosidebarSmeRoute = LayoutNosidebarSmeRouteImport.update({
  id: '/sme',
  path: '/sme',
  getParentRoute: () => LayoutNosidebarRoute,
} as any)
const LayoutNosidebarSalesforceRoute =
  LayoutNosidebarSalesforceRouteImport.update({
    id: '/salesforce',
    path: '/salesforce',
    getParentRoute: () => LayoutNosidebarRoute,
  } as any)
const LayoutNosidebarQuestionnaireRoute =
  LayoutNosidebarQuestionnaireRouteImport.update({
    id: '/questionnaire',
    path: '/questionnaire',
    getParentRoute: () => LayoutNosidebarRoute,
  } as any)
const LayoutNosidebarManageUsersRoute =
  LayoutNosidebarManageUsersRouteImport.update({
    id: '/manageUsers',
    path: '/manageUsers',
    getParentRoute: () => LayoutNosidebarRoute,
  } as any)
const LayoutNosidebarManageRolesRoute =
  LayoutNosidebarManageRolesRouteImport.update({
    id: '/manageRoles',
    path: '/manageRoles',
    getParentRoute: () => LayoutNosidebarRoute,
  } as any)
const LayoutNosidebarManageRequestsRoute =
  LayoutNosidebarManageRequestsRouteImport.update({
    id: '/manageRequests',
    path: '/manageRequests',
    getParentRoute: () => LayoutNosidebarRoute,
  } as any)
const LayoutNosidebarFeedbackRoute = LayoutNosidebarFeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => LayoutNosidebarRoute,
} as any)
const LayoutNosidebarDocumentsRoute =
  LayoutNosidebarDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => LayoutNosidebarRoute,
  } as any)
const LayoutChatsChatIdRoute = LayoutChatsChatIdRouteImport.update({
  id: '/$chatId',
  path: '/$chatId',
  getParentRoute: () => LayoutChatsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof LayoutIndexRoute
  '/copilot': typeof CopilotRoute
  '/widget-redirect': typeof WidgetRedirectRoute
  '/documents': typeof LayoutNosidebarDocumentsRoute
  '/feedback': typeof LayoutNosidebarFeedbackRoute
  '/manageRequests': typeof LayoutNosidebarManageRequestsRoute
  '/manageRoles': typeof LayoutNosidebarManageRolesRoute
  '/manageUsers': typeof LayoutNosidebarManageUsersRoute
  '/questionnaire': typeof LayoutNosidebarQuestionnaireRoute
  '/salesforce': typeof LayoutNosidebarSalesforceRoute
  '/sme': typeof LayoutNosidebarSmeRoute
  '/spotlight': typeof LayoutNosidebarSpotlightRoute
  '/unauthorized': typeof LayoutNosidebarUnauthorizedRoute
  '/welcome': typeof LayoutNosidebarWelcomeRoute
  '/chats': typeof LayoutChatsRouteWithChildren
  '/widget/chat': typeof WidgetChatRoute
  '/chats/$chatId': typeof LayoutChatsChatIdRoute
}
export interface FileRoutesByTo {
  '/': typeof LayoutIndexRoute
  '/copilot': typeof CopilotRoute
  '/widget-redirect': typeof WidgetRedirectRoute
  '/documents': typeof LayoutNosidebarDocumentsRoute
  '/feedback': typeof LayoutNosidebarFeedbackRoute
  '/manageRequests': typeof LayoutNosidebarManageRequestsRoute
  '/manageRoles': typeof LayoutNosidebarManageRolesRoute
  '/manageUsers': typeof LayoutNosidebarManageUsersRoute
  '/questionnaire': typeof LayoutNosidebarQuestionnaireRoute
  '/salesforce': typeof LayoutNosidebarSalesforceRoute
  '/sme': typeof LayoutNosidebarSmeRoute
  '/spotlight': typeof LayoutNosidebarSpotlightRoute
  '/unauthorized': typeof LayoutNosidebarUnauthorizedRoute
  '/welcome': typeof LayoutNosidebarWelcomeRoute
  '/chats': typeof LayoutChatsRouteWithChildren
  '/widget/chat': typeof WidgetChatRoute
  '/chats/$chatId': typeof LayoutChatsChatIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_layout': typeof LayoutRouteWithChildren
  '/_layout-nosidebar': typeof LayoutNosidebarRouteWithChildren
  '/copilot': typeof CopilotRoute
  '/widget-redirect': typeof WidgetRedirectRoute
  '/_layout-nosidebar/documents': typeof LayoutNosidebarDocumentsRoute
  '/_layout-nosidebar/feedback': typeof LayoutNosidebarFeedbackRoute
  '/_layout-nosidebar/manageRequests': typeof LayoutNosidebarManageRequestsRoute
  '/_layout-nosidebar/manageRoles': typeof LayoutNosidebarManageRolesRoute
  '/_layout-nosidebar/manageUsers': typeof LayoutNosidebarManageUsersRoute
  '/_layout-nosidebar/questionnaire': typeof LayoutNosidebarQuestionnaireRoute
  '/_layout-nosidebar/salesforce': typeof LayoutNosidebarSalesforceRoute
  '/_layout-nosidebar/sme': typeof LayoutNosidebarSmeRoute
  '/_layout-nosidebar/spotlight': typeof LayoutNosidebarSpotlightRoute
  '/_layout-nosidebar/unauthorized': typeof LayoutNosidebarUnauthorizedRoute
  '/_layout-nosidebar/welcome': typeof LayoutNosidebarWelcomeRoute
  '/_layout/chats': typeof LayoutChatsRouteWithChildren
  '/widget/chat': typeof WidgetChatRoute
  '/_layout/': typeof LayoutIndexRoute
  '/_layout/chats/$chatId': typeof LayoutChatsChatIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/copilot'
    | '/widget-redirect'
    | '/documents'
    | '/feedback'
    | '/manageRequests'
    | '/manageRoles'
    | '/manageUsers'
    | '/questionnaire'
    | '/salesforce'
    | '/sme'
    | '/spotlight'
    | '/unauthorized'
    | '/welcome'
    | '/chats'
    | '/widget/chat'
    | '/chats/$chatId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/copilot'
    | '/widget-redirect'
    | '/documents'
    | '/feedback'
    | '/manageRequests'
    | '/manageRoles'
    | '/manageUsers'
    | '/questionnaire'
    | '/salesforce'
    | '/sme'
    | '/spotlight'
    | '/unauthorized'
    | '/welcome'
    | '/chats'
    | '/widget/chat'
    | '/chats/$chatId'
  id:
    | '__root__'
    | '/_layout'
    | '/_layout-nosidebar'
    | '/copilot'
    | '/widget-redirect'
    | '/_layout-nosidebar/documents'
    | '/_layout-nosidebar/feedback'
    | '/_layout-nosidebar/manageRequests'
    | '/_layout-nosidebar/manageRoles'
    | '/_layout-nosidebar/manageUsers'
    | '/_layout-nosidebar/questionnaire'
    | '/_layout-nosidebar/salesforce'
    | '/_layout-nosidebar/sme'
    | '/_layout-nosidebar/spotlight'
    | '/_layout-nosidebar/unauthorized'
    | '/_layout-nosidebar/welcome'
    | '/_layout/chats'
    | '/widget/chat'
    | '/_layout/'
    | '/_layout/chats/$chatId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  LayoutRoute: typeof LayoutRouteWithChildren
  LayoutNosidebarRoute: typeof LayoutNosidebarRouteWithChildren
  CopilotRoute: typeof CopilotRoute
  WidgetRedirectRoute: typeof WidgetRedirectRoute
  WidgetChatRoute: typeof WidgetChatRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/widget-redirect': {
      id: '/widget-redirect'
      path: '/widget-redirect'
      fullPath: '/widget-redirect'
      preLoaderRoute: typeof WidgetRedirectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/copilot': {
      id: '/copilot'
      path: '/copilot'
      fullPath: '/copilot'
      preLoaderRoute: typeof CopilotRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout-nosidebar': {
      id: '/_layout-nosidebar'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LayoutNosidebarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout/': {
      id: '/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LayoutIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/widget/chat': {
      id: '/widget/chat'
      path: '/widget/chat'
      fullPath: '/widget/chat'
      preLoaderRoute: typeof WidgetChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout/chats': {
      id: '/_layout/chats'
      path: '/chats'
      fullPath: '/chats'
      preLoaderRoute: typeof LayoutChatsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout-nosidebar/welcome': {
      id: '/_layout-nosidebar/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof LayoutNosidebarWelcomeRouteImport
      parentRoute: typeof LayoutNosidebarRoute
    }
    '/_layout-nosidebar/unauthorized': {
      id: '/_layout-nosidebar/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof LayoutNosidebarUnauthorizedRouteImport
      parentRoute: typeof LayoutNosidebarRoute
    }
    '/_layout-nosidebar/spotlight': {
      id: '/_layout-nosidebar/spotlight'
      path: '/spotlight'
      fullPath: '/spotlight'
      preLoaderRoute: typeof LayoutNosidebarSpotlightRouteImport
      parentRoute: typeof LayoutNosidebarRoute
    }
    '/_layout-nosidebar/sme': {
      id: '/_layout-nosidebar/sme'
      path: '/sme'
      fullPath: '/sme'
      preLoaderRoute: typeof LayoutNosidebarSmeRouteImport
      parentRoute: typeof LayoutNosidebarRoute
    }
    '/_layout-nosidebar/salesforce': {
      id: '/_layout-nosidebar/salesforce'
      path: '/salesforce'
      fullPath: '/salesforce'
      preLoaderRoute: typeof LayoutNosidebarSalesforceRouteImport
      parentRoute: typeof LayoutNosidebarRoute
    }
    '/_layout-nosidebar/questionnaire': {
      id: '/_layout-nosidebar/questionnaire'
      path: '/questionnaire'
      fullPath: '/questionnaire'
      preLoaderRoute: typeof LayoutNosidebarQuestionnaireRouteImport
      parentRoute: typeof LayoutNosidebarRoute
    }
    '/_layout-nosidebar/manageUsers': {
      id: '/_layout-nosidebar/manageUsers'
      path: '/manageUsers'
      fullPath: '/manageUsers'
      preLoaderRoute: typeof LayoutNosidebarManageUsersRouteImport
      parentRoute: typeof LayoutNosidebarRoute
    }
    '/_layout-nosidebar/manageRoles': {
      id: '/_layout-nosidebar/manageRoles'
      path: '/manageRoles'
      fullPath: '/manageRoles'
      preLoaderRoute: typeof LayoutNosidebarManageRolesRouteImport
      parentRoute: typeof LayoutNosidebarRoute
    }
    '/_layout-nosidebar/manageRequests': {
      id: '/_layout-nosidebar/manageRequests'
      path: '/manageRequests'
      fullPath: '/manageRequests'
      preLoaderRoute: typeof LayoutNosidebarManageRequestsRouteImport
      parentRoute: typeof LayoutNosidebarRoute
    }
    '/_layout-nosidebar/feedback': {
      id: '/_layout-nosidebar/feedback'
      path: '/feedback'
      fullPath: '/feedback'
      preLoaderRoute: typeof LayoutNosidebarFeedbackRouteImport
      parentRoute: typeof LayoutNosidebarRoute
    }
    '/_layout-nosidebar/documents': {
      id: '/_layout-nosidebar/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof LayoutNosidebarDocumentsRouteImport
      parentRoute: typeof LayoutNosidebarRoute
    }
    '/_layout/chats/$chatId': {
      id: '/_layout/chats/$chatId'
      path: '/$chatId'
      fullPath: '/chats/$chatId'
      preLoaderRoute: typeof LayoutChatsChatIdRouteImport
      parentRoute: typeof LayoutChatsRoute
    }
  }
}

interface LayoutChatsRouteChildren {
  LayoutChatsChatIdRoute: typeof LayoutChatsChatIdRoute
}

const LayoutChatsRouteChildren: LayoutChatsRouteChildren = {
  LayoutChatsChatIdRoute: LayoutChatsChatIdRoute,
}

const LayoutChatsRouteWithChildren = LayoutChatsRoute._addFileChildren(
  LayoutChatsRouteChildren,
)

interface LayoutRouteChildren {
  LayoutChatsRoute: typeof LayoutChatsRouteWithChildren
  LayoutIndexRoute: typeof LayoutIndexRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutChatsRoute: LayoutChatsRouteWithChildren,
  LayoutIndexRoute: LayoutIndexRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

interface LayoutNosidebarRouteChildren {
  LayoutNosidebarDocumentsRoute: typeof LayoutNosidebarDocumentsRoute
  LayoutNosidebarFeedbackRoute: typeof LayoutNosidebarFeedbackRoute
  LayoutNosidebarManageRequestsRoute: typeof LayoutNosidebarManageRequestsRoute
  LayoutNosidebarManageRolesRoute: typeof LayoutNosidebarManageRolesRoute
  LayoutNosidebarManageUsersRoute: typeof LayoutNosidebarManageUsersRoute
  LayoutNosidebarQuestionnaireRoute: typeof LayoutNosidebarQuestionnaireRoute
  LayoutNosidebarSalesforceRoute: typeof LayoutNosidebarSalesforceRoute
  LayoutNosidebarSmeRoute: typeof LayoutNosidebarSmeRoute
  LayoutNosidebarSpotlightRoute: typeof LayoutNosidebarSpotlightRoute
  LayoutNosidebarUnauthorizedRoute: typeof LayoutNosidebarUnauthorizedRoute
  LayoutNosidebarWelcomeRoute: typeof LayoutNosidebarWelcomeRoute
}

const LayoutNosidebarRouteChildren: LayoutNosidebarRouteChildren = {
  LayoutNosidebarDocumentsRoute: LayoutNosidebarDocumentsRoute,
  LayoutNosidebarFeedbackRoute: LayoutNosidebarFeedbackRoute,
  LayoutNosidebarManageRequestsRoute: LayoutNosidebarManageRequestsRoute,
  LayoutNosidebarManageRolesRoute: LayoutNosidebarManageRolesRoute,
  LayoutNosidebarManageUsersRoute: LayoutNosidebarManageUsersRoute,
  LayoutNosidebarQuestionnaireRoute: LayoutNosidebarQuestionnaireRoute,
  LayoutNosidebarSalesforceRoute: LayoutNosidebarSalesforceRoute,
  LayoutNosidebarSmeRoute: LayoutNosidebarSmeRoute,
  LayoutNosidebarSpotlightRoute: LayoutNosidebarSpotlightRoute,
  LayoutNosidebarUnauthorizedRoute: LayoutNosidebarUnauthorizedRoute,
  LayoutNosidebarWelcomeRoute: LayoutNosidebarWelcomeRoute,
}

const LayoutNosidebarRouteWithChildren = LayoutNosidebarRoute._addFileChildren(
  LayoutNosidebarRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  LayoutRoute: LayoutRouteWithChildren,
  LayoutNosidebarRoute: LayoutNosidebarRouteWithChildren,
  CopilotRoute: CopilotRoute,
  WidgetRedirectRoute: WidgetRedirectRoute,
  WidgetChatRoute: WidgetChatRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
